module.exports = __webpack_public_path__ + "platform/static/media/bidd-first-im.6d48a18b.webp";